import React from "react";
import { useSelector } from 'react-redux';
import { getStatusColor } from "../helpers/helpers";
import './NotificationsList.scss';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const NotificationsList = props => {
    const { t } = useSelector(selector);
    const { notifications, title, viewAllButton } = props;

    return (
        <div className='notificationsListWrapper'>
            <div className='notificationsListHeader'>
                <span className='notificationsListTitle'>
                    {title}
                </span>
                {viewAllButton &&
                    <div className='notificationsListExpandButton'>
                        {t.gettext('View All')}
                    </div>
                }
            </div>

            {!notifications.length && <div>{t.gettext('No notifications')}</div>}

            <ul className='notificationsList'>
                {notifications.map(notification =>
                    <li className='notificationsListItem' key={notification.id}>
                        <div className='notificationsListItemLeft'>
                            <div
                                className={
                                    'notificationsListItemLeftTop'
                                }
                                style={{borderColor: getStatusColor(notification.temperatureStatus), color: getStatusColor(notification.temperatureStatus)}}
                            >
                                {Math.round(notification.temperature)}c
                            </div>
                            <div className='notificationsListItemLeftBottom'>{notification.dateTimeCreated.split('T').shift()}</div>
                            <div className='notificationsListItemLeftBottom'>{notification.dateTimeCreated.split('T').pop().substring(0,5)}</div>
                            <div
                                className={
                                    'notificationsListItemCircle'
                                }
                                style={{background: getStatusColor(notification.temperatureStatus)}}
                            />
                        </div>
                        <div className='notificationsListItemRight'>
                            {notification.message}
                        </div>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default NotificationsList;
